import { get, post } from "../fetch.v2"
import { getDomainId, getEventId } from "../../utils/store"

class UserLinkApi {
  url: string

  constructor(userId: number) {
    this.url = `/domains/${getDomainId()}/events/${getEventId()}/users/${userId}/links`
  }

  async getAllByUserId() {
    return get(this.url)
  }

  async createOne(userIdB: number) {
    return post(`${this.url}/${userIdB}`)
  }
}

export default UserLinkApi
